import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { FQAN_jedgrad_id } from '@app/components/hierarhija/hierarhija.component';
import { AppConfig, appConfigService } from '@app/config';
import { AuthRequestOptions } from '@ntap/core';
import { map, ReplaySubject, switchMap } from 'rxjs';

export type ClipboardJedinicaDTO = {
  item: any;
  moveOriginalJedinica: boolean;
};

@Injectable({ providedIn: 'root' })
export class PremjestiDokJedinicuService {
  constructor(
    private http: HttpClient,
    @Inject(appConfigService) private config: AppConfig
  ) {}
  private _clipboardJedinica = new ReplaySubject<ClipboardJedinicaDTO>(1);
  public clipboardJedinica$ = this._clipboardJedinica.asObservable();

  copyJedinica(jedinica: any) {
    this._clipboardJedinica.next({
      item: jedinica,
      moveOriginalJedinica: false
    });
  }

  cutJedinica(jedinica: any) {
    this._clipboardJedinica.next({
      item: jedinica,
      moveOriginalJedinica: true
    });
  }

  pasteJedinica(targetJedinica: any) {
    return this.clipboardJedinica$.pipe(
      switchMap((sourceJedinica: ClipboardJedinicaDTO) => {
        return this.executePasteJedinica(
          sourceJedinica.item,
          targetJedinica,
          sourceJedinica.moveOriginalJedinica
        );
      })
    );
  }

  clearClipboard() {
    this._clipboardJedinica.next({ item: null, moveOriginalJedinica: false });
    // this._clipboardJedinica.complete();
  }

  private executePasteJedinica(
    sourceJedinica: any,
    targetJedinica: any,
    moveOriginalJedinica: boolean
  ) {
    const sourceJedinicaId = sourceJedinica[FQAN_jedgrad_id];
    const targetJedinicaId = targetJedinica[FQAN_jedgrad_id];
    let apiPath = 'premjesti-dok-jedinicu';
    if (!moveOriginalJedinica) {
      apiPath = 'kopiraj-dok-jedinicu';
    }
    const url = `${this.config.apiHost}${apiPath}?sourceJedinicaId=${sourceJedinicaId}&targetJedinicaId=${targetJedinicaId}`;
    return this.http.get(url, new AuthRequestOptions()).pipe(map((res) => res));
  }
}
